var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconLeftDoubleArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9 11.302l-4.6-4.6a.883.883 0 01-.213-.325 1.067 1.067 0 01-.061-.375c0-.134.02-.259.063-.375a.888.888 0 01.212-.325l4.6-4.6a.976.976 0 01.688-.287.931.931 0 01.712.287.948.948 0 01.275.7.948.948 0 01-.275.7l-3.876 3.9 3.875 3.9a.98.98 0 01.288.688.925.925 0 01-.288.712.948.948 0 01-.7.274.948.948 0 01-.7-.274zm-6.6 0l-4.6-4.6a.883.883 0 01-.213-.325 1.083 1.083 0 01-.062-.375c0-.134.02-.259.063-.375A.888.888 0 01.7 5.302l4.6-4.6a.976.976 0 01.688-.287.931.931 0 01.712.287.948.948 0 01.275.7.948.948 0 01-.275.7l-3.875 3.9 3.875 3.9a.98.98 0 01.288.688.925.925 0 01-.288.712.948.948 0 01-.7.274.948.948 0 01-.7-.274z",
    fill: "#A8A9AC"
  })));
}

export default SvgIconLeftDoubleArrow;